module.exports = __webpack_public_path__ + "static/media/icon-clip-grey.aff69c22.svg";